import { render, staticRenderFns } from "./ui-notification.vue?vue&type=template&id=4d0fb5e8&scoped=true&"
import script from "./ui-notification.vue?vue&type=script&lang=ts&"
export * from "./ui-notification.vue?vue&type=script&lang=ts&"
import style0 from "./ui-notification.vue?vue&type=style&index=0&id=4d0fb5e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0fb5e8",
  null
  
)

export default component.exports